import type { FaireProductEntity } from "../../entity_types/product";

export const p_7jhvyc3mse: FaireProductEntity = {
  token: "p_7jhvyc3mse",
  type: "product",
  name: "Pick Joy! Deluxe Self Care Gift Box",
  brandToken: "b_h5zsy5juqx",
  brandName: "Alaska Beauty Peony Cooperative",
  imageUrl:
    "https://cdn.faire.com/fastly/06ceea2279d3994e5ce5f2e317fc634cab08668934a6416de3e789171c1ae671.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/542723b08701ff05b8c4b4e70129ea85e99784c4dc6e441cd64e93ce8e041867.jpeg",
    "https://cdn.faire.com/fastly/380789f1ffa038b3b8b84659127e75104437df61dce98f36b0fab1e29aaebaba.jpeg",
  ],
  priceDollars: 50,
  description:
    "We are so excited to release one of our newest products for 2025.\n\nThe Pick Joy Deluxe Self Care Gift Box!\n\nThis unique gift box includes some of our most popular products and one of our newest product releases.\n\n• Peony Soak 10 oz - Ingredients: Epsom Salt, Alaska Peonies, Kachemak Bay Sea Salt, Fractured Coconut Oil, and organic citrus essential oil.\n• Peony Soap - Ingredients: organic extra virgin olive oil, organic coconut oil, organic fair trade shea butter, pure Alaskan water, sodium hydroxide, organic sunflower oil, organic lavender, orange, and rose geranium essential oils, rosemary extract (antioxidant), and peony petals.\n• Natural Sisal Soap Pouch\n• Peony Sticker Set of 2 - 3” Thick, durable vinyl protects these stickers from scratches, water & sunlight.\n• Natural Honey Sticks\n• And a 1oz pouch of our favorite Alaska Peony Earl Grey Tea",
  tags: [],
  msrpDollars: 100,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:41.255Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
